<template>
   <div class="main">
   <div class="control-section">
    <div class="ptitle"> PANEL GŁÓWNY </div>
    <!--  DashboardLayout element declaration -->
    <ejs-dashboardlayout id='dashboard_default' :cellSpacing='cellSpacing' :columns="4" :allowResizing="false" :allowDragging="false">
      <e-panels>
		<e-panel :row="1" :col="1" content="<div class='content'>PRZYJĘCIE NA<br/> MAGAZYN</div>"></e-panel>
        <e-panel :row="1" :col="2" content="<div class='content'>WYDANIE <br/>Z MAGAZYNU</div>"></e-panel>
        <e-panel :row="2" :col="1" content="<div class='content'>ODSORTY</div>"></e-panel>
        <e-panel :row="2" :col="2" content="<div class='content'>PRZYJĘCIE WYROBU GOTOWEGO</div>"></e-panel>
      </e-panels>
    </ejs-dashboardlayout>
    <!-- end of dashboardlayout element -->
   </div>
	<fullscreen class="fullscreen-wrapper" v-model="fullscreen">
    </fullscreen>
	<div class="fs-box">
    <button class="fullscrbtn" type="button" @click="toggleApi" >{{btnTitle}}</button>
    </div>
    <div class="logout">
    	<button id="logout">Wyloguj</button>
    </div>
   </div>
</template>


<script>
import { DashboardLayoutComponent, PanelDirective, PanelsDirective } from "@syncfusion/ej2-vue-layouts";
import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
import "../../node_modules/@syncfusion/ej2-vue-layouts/styles/material.css";
import Storage from "./Storage";

export default {
  name: "app2",
  components: { 
	"ejs-dashboardlayout": DashboardLayoutComponent,
        "e-panels":PanelsDirective,
        "e-panel":PanelDirective,
  },
  data() {
      return {
		fullscreen: false,
		btnTitle: 'Pełny ekran',
          aspectRatio: 100/85,
          cellSpacing: [10,10],
      }
  },  
  watch:{
    fullscreen(){
      if(this.fullscreen === false){
        this.btnTitle = 'Pełny ekran'
      }
      else{
        this.btnTitle = 'Pełny ekran'
      }
    }
  },
  methods: {
	toggle () {
      this.fullscreen = !this.fullscreen
      console.log(this.btnTitle)
    },
    toggleApi () {
      this.$fullscreen.toggle()
      this.fullscreen = !this.fullscreen
      console.log(this.btnTitle)
    },
	panel1click() {
		//alert("panel1: " + this.myGlobalVariable);
		this.$router.push({ path: "/dokumentypz" });
	},
	panel2click() {
		//alert("panel2: " + this.myRouter);
		this.$router.push({ path: "/zleceniawydanie" });
	},
	panel3click() {
		//alert("panel3");
		this.$router.push({ path: "/zleceniaodpady" });
	},
	panel4click() {
		//alert("panel4");
		this.$router.push({ path: "/zleceniaartykul" });
	},
	logoutclick() {
		Storage.cleanJWT().then(resp => {
			this.$router.push({ path: "/" });
		});
	}
  },
  mounted() {
	var that = this;
	document.querySelector("#layout_0").addEventListener('click', function() { that.panel1click(); } );
	document.querySelector("#layout_1").addEventListener('click', function() { that.panel2click(); } );
	document.querySelector("#layout_2").addEventListener('click', function() { that.panel3click(); } );
	document.querySelector("#layout_3").addEventListener('click', function() { that.panel4click(); } );
	document.querySelector("#logout").addEventListener('click', function() { that.logoutclick(); } );
  }
}


</script>

<style> 
.ptitle {
  margin-bottom:20px;
  margin-left: 260px;
  text-align: left;
}

/* DashboardLayout element styles  */
#dashboard_default .e-panel .e-panel-container .content {
  vertical-align: middle;
  font-weight: 600;
  font-size: 20px;
  text-align: center;
  line-height: 50px;
  margin-top: 30px;
}

#dashboard_default .e-panel {
  transition:none !important;
}

.logout {
	width: 200px;
	height: 50px;
	position:fixed;
  	bottom: 10px;
	text-align: left;
	background-color: #FFFFFF;
	float: left;
	/*margin-left: 400px;*/
}
#logout {
	width: 200px;
	height: 50px;
	position:relative;
	background-color: #FFFFFF;
}
.fullscrbtn{
  	color: #FFFFFF;
    background-color: royalblue;
    width: 200px;
    height: 40px;
    float: center;
}
@media screen and (max-width: 1024px){
.fs-box{
    position:fixed;
    bottom: 60px;
    width: 100%;
}
}
@media screen and (min-width: 1025px){
.fs-box{
    display: none;
    position:fixed;
    bottom: 60px;
    width: 100%;
}
}
.fullscreen-wrapper {
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  }
</style> 



// WEBPACK FOOTER //
// src/components/PanelContent.vue